import React, { useEffect, useState } from 'react';
import * as api from '../../../services/oldApiService';
import { useAuth } from 'context/AuthContext';
import { Box, Grid, Paper, Alert, IconButton, Typography, Button } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import useNotVerifiedStyles from './Styles';
import { colors } from 'styles/colors';
import { snackbarService } from 'services/snackbarService';
import useStyles from './Styles';

const RESEND_TIME = 59;

const NotVerifiedPage: React.FC = () => {
  const { user, logout } = useAuth();
  const styles = useStyles();
  const [codeSent, setCodeSent] = useState(false);
  const [timer, setTimer] = useState(RESEND_TIME);

  const resendVerifyLink = React.useCallback(async () => {
    setCodeSent(true);
    setTimer(RESEND_TIME);

    const { data, status_code: statusCode } = await api.resendVerificationCode(
      user.id
    );
    if (statusCode === api.status.SUCCESS) {
      snackbarService.showSnackbar(data?.message, 'success');
    } else {
      snackbarService.showSnackbar(data, 'error');
    }
  }, []);

  /** ---------------- TIMER LOGIC ---------------- */
  useEffect(() => {
    if (!codeSent || timer === 0) return;

    const interval = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [codeSent, timer]);

  useEffect(() => {
    if (timer === 0) {
      setCodeSent(false);
      setTimer(RESEND_TIME);
    }
  }, [timer]);

  return (
    <Box className={styles.container} p={3}>
      <Grid
        container
        justifyContent="center"
      >
        <Grid
          size={{
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12,
          }}>
          <Paper elevation={0} className={styles.box}>
            <Box display='flex' flexDirection='row' my={2}>
              <VerifiedUserIcon sx={{ color: colors.primary }} />
              <Typography pl={1}>Verify</Typography>
            </Box>
            <Box>
              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                size={{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 12,
                }}
              >
                <Typography
                  variant="body2"
                  color={colors.gray}
                >
                  In order to continue to MS Logger, you must verify
                  your account.
                  <br />
                  <br /> An email has been sent to{' '}
                  <span className='email'>
                    {user ? user.email : null}
                  </span>{' '}
                  with a link to verify your account.
                  <br />
                  If you have not received the verification
                  email after a few minutes, Please check your spam
                  folder.
                </Typography>
              </Grid>
              <br />
              <Grid
                container
                direction="row"
                justifyContent='space-between'
                size={{
                  xs: 12,
                  sm: 12,
                  md: 12,
                  lg: 12,
                }}
              >
                <Typography
                  variant="body1"
                  className="resendLink"
                  color={codeSent ? colors.gray : colors.link}
                  onClick={codeSent ? undefined : resendVerifyLink}
                  sx={{
                    cursor: codeSent ? 'default' : 'pointer',
                  }}
                >
                  {codeSent
                    ? `You can resend code in ${timer}s`
                    : 'Re-send the verification email'}
                </Typography>

                <Typography
                  variant="body2"
                  className='resendLink'
                  color={colors.error}
                  onClick={() => logout()}
                  sx={{
                    cursor: 'pointer'
                  }}

                >
                  Logout
                </Typography>
              </Grid>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NotVerifiedPage;
